import React from 'react';
import { Link } from 'react-router-dom';
import { Button } from './Button';
import { track } from '../utils/analytics';

const BOOK_DEMO_URL = 'https://calendly.com/rcarloc029/30min';

export function Header() {
  return (
    <header className="sticky top-0 z-50 w-full border-b border-gray-200 bg-white/80 backdrop-blur-md">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 h-16 flex items-center justify-between">
        <div className="flex items-center gap-8">
          <Link to="/" className="flex flex-col leading-none">
            <span className="font-serif font-bold text-xl text-[var(--color-csai-primary)] tracking-tight">ORCA</span>
            <span className="text-[10px] font-medium text-[var(--color-csai-primary)] tracking-[0.3em]">by Situs Canada</span>
          </Link>

          <nav className="hidden md:flex items-center gap-6 text-sm font-medium text-gray-600">
            <Link to="/" className="hover:text-black transition-colors">For CPAs</Link>
            <Link to="/pricing" className="hover:text-black transition-colors">Pricing</Link>
            <Link to="/security" className="hover:text-black transition-colors">Security</Link>
            <Link to="/about" className="hover:text-black transition-colors">About</Link>
          </nav>
        </div>

        <div className="flex items-center gap-3">
          <Link to="/login" className="hidden sm:block text-sm font-medium text-gray-600 hover:text-black transition-colors">
            Sign In
          </Link>
          <a
            href={BOOK_DEMO_URL}
            target="_blank"
            rel="noopener noreferrer"
            onClick={() => track('book_demo_click', { page: 'home', section: 'nav', cta_label: 'Book demo' })}
          >
            <Button className="rounded-full px-5">Book demo</Button>
          </a>
        </div>
      </div>
    </header>
  );
}
